import { Dispatch } from 'redux'
import {
  activeFeedbackTabSelector,
  feedbacksSelector,
  sentenceOffsetsSelector,
} from '@chegg-wt/core-wa/state/selectors'
import { FeedbackType } from '@chegg-wt/core-wa/types'
import { FeedbackTab } from '@chegg-wt/core-wa/constants/paraphraser'
import { setFeedbacks } from '@chegg-wt/core-wa/state/actions'
import { AppState } from '@chegg-wt/core/state/types'
import getFeatureEditor from '../../getEditor'

export const removeOldFeedbacks = (
  grammarSentenceIds: Set<String>,
  paraphraseSentenceIds: Set<String>,
  state: AppState,
  dispatch: Dispatch
) => {
  if (grammarSentenceIds.size === 0 && paraphraseSentenceIds.size === 0) {
    // Optimization when we have no sentenceId to remove
    return
  }
  const editor = getFeatureEditor()
  const activeFeedbackTab = activeFeedbackTabSelector(state)
  const sentenceOffsets = sentenceOffsetsSelector(state)
  const feedbacks = feedbacksSelector(state)
  const filteredFeedbacks = feedbacks.filter((feedback) => {
    return !(
      (feedback.feedbackType === FeedbackType.GRAMMAR &&
        grammarSentenceIds.has(feedback.sentenceId)) ||
      (feedback.feedbackType === FeedbackType.PARAPHRASE &&
        paraphraseSentenceIds.has(feedback.sentenceId))
    )
  })
  const removedIds =
    activeFeedbackTab === FeedbackTab.GRAMMAR_TAB
      ? grammarSentenceIds
      : paraphraseSentenceIds
  // Remove underline for open tab
  dispatch(setFeedbacks(filteredFeedbacks))
  editor.commands.forEach(Array.from(removedIds), (removedId, { chain }) => {
    const { id, offset, length } =
      sentenceOffsets.find((sentence) => sentence.id === removedId) || {}
    if (!id) return true
    return chain()
      .removeCustomHighlight({ id, offset, length })
      .removeCustomUnderline({ id, offset, length })
      .run()
  })
}
